import React from "react";
import { BillWatchProps } from "../BillWatchProps";
import { BillWatchLayout } from '../BillWatchLayout';
import { BillWatchEntities } from "../BillWatchEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface RuleListPageProps extends NSARouterMakerResult, BillWatchProps { }

export default class RuleListPage extends React.Component<RuleListPageProps>
{
	override render()
	{
		return (
			<BillWatchLayout
				{...this.props}
				action={{
					description: "You can view all your previously created rules, including their formulas, thresholds, and change types.",
					menus: {}
				}}
				pages={{
					entity: BillWatchEntities.rule(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>
			</BillWatchLayout>
		);
	}
}